import type {
  NormalizedPayrollEmployeeRecord,
  NormalizedPayrollResult,
  PayrollParseResult,
} from './payrollTypes';

function buildEmployeeKey(competence: string | undefined, employeeId: string): string {
  return `${competence ?? 'unknown'}::${employeeId}`;
}

/**
 * Normaliza o resultado do parser para uso no front:
 * - adiciona competência em cada registro
 * - gera chave única por competência+employeeId
 * - marca duplicados (para bloquear gravação duplicada)
 */
export function normalizePayrollResult(parsed: PayrollParseResult): NormalizedPayrollResult {
  const competence = parsed.run?.competence;
  const seen = new Set<string>();
  const employees: NormalizedPayrollEmployeeRecord[] = [];
  const duplicates: NormalizedPayrollEmployeeRecord[] = [];

  parsed.employees.forEach((emp, sourceIndex) => {
    const uniqueKey = buildEmployeeKey(competence, emp.employeeId);
    const isDuplicate = seen.has(uniqueKey);
    const normalized: NormalizedPayrollEmployeeRecord = {
      ...emp,
      competence,
      uniqueKey,
      isDuplicate,
      sourceIndex,
    };

    if (isDuplicate) {
      duplicates.push(normalized);
    } else {
      seen.add(uniqueKey);
      employees.push(normalized);
    }
  });

  return {
    run: parsed.run,
    departments: parsed.departments,
    employees,
    duplicates,
    issues: parsed.issues,
    rawText: parsed.rawText,
  };
}
